import { IoCloseCircle } from "react-icons/io5";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { Button } from "../../../../../components";
import { useState, useEffect, useRef } from "react";
import { IoIosAddCircle } from "react-icons/io";
import "../NudgeFieldsURL/styles.css";
import ModalPopUp,{ModalPopUp2,ModalPopUpForSeoKeywords} from "../../../../../helper/modalPopUp/ModalPopUp";
import { Scrollbar } from "react-scrollbars-custom";
import { useSelector } from "react-redux";
import { SelectUserWebsiteURL } from "../../../../../common/authenticateDashboard/authSlice";
import { set } from "date-fns";
const NudgeFieldsURL = (props) => {
  const {
    nudgeFields,
    setNudgeFields,
    customizeState,
    setCustomizeState,
    handleSave,
    nudgeTitle
  } = props;
  const [urlField, setURLField] = useState("");
  const [allowedURLs, setAllowedURLs] = useState(
    customizeState?.nudgeShowing?.allowed !== undefined
      ? customizeState?.nudgeShowing?.allowed
      : []
  );

  console.log("nudgeFields", nudgeFields);
  console.log("ip customizeState", customizeState);

  const [prohibitedURLs, setProhibitedURLs] = useState(
    customizeState ? customizeState?.nudgeShowing?.prohibited : []
  );

  return (
    <div className="customisableFields lg:w-1/2 p-2 w-full">
      <div className="flex">
        <h3 className="mx-auto text-xl font-semibold">
          {nudgeFields.optionName}
        </h3>
      </div>

      <div className="fields">
        {nudgeFields?.customizeProperties &&
          Object.entries(nudgeFields?.customizeProperties).map(
            ([propertyName, propertyValue], index) => {
              // console.log("Test", propertyName, propertyValue);
              return (
                <Fields
                  key={index}
                  propertyName={propertyName}
                  property={propertyValue}
                  customizeState={customizeState}
                  setCustomizeState={setCustomizeState}
                  nudgeFields={nudgeFields}
                  setNudgeFields={setNudgeFields}
                  urlField={urlField}
                  setURLField={setURLField}
                  allowedURLs={allowedURLs}
                  setAllowedURLs={setAllowedURLs}
                  prohibitedURLs={prohibitedURLs}
                  setProhibitedURLs={setProhibitedURLs}
                  nudgeTitle={nudgeTitle}
                />
              );
            }
          )}

      </div>
      <div className="buttons flex mt-4 items-center justify-center">
        <Button
          Icon={AiOutlineCloudUpload}
          active={false}
          onClick={handleSave}
          title="SAVE"
        />
      </div>
    </div>
  );
};

const Fields = (props) => {
  const [maxLengthErrorText, setMaxLengthErrorText] = useState("");

  const {
    propertyName,
    property,
    customizeState,
    setCustomizeState,
    nudgeFields,
    setNudgeFields,
    urlField,
    setURLField,
    allowedURLs,
    setAllowedURLs,
    prohibitedURLs,
    setProhibitedURLs,
    nudgeTitle
  } = props;

  console.log("Fields customizeState->", customizeState);

  const handleNudgeFieldsChange = (name, value = "") => {
    // check if text length is greater than property.propertyMaxLength
    console.log("name", name, "value", value);
    if (
      property?.propertyMaxLength &&
      value.length > property.propertyMaxLength
    ) {
      setMaxLengthErrorText(`Max length is ${property.propertyMaxLength}`);
      return;
    }
    setMaxLengthErrorText("");

    let state = {
      ...customizeState,
      [nudgeFields.optionValue]: {
        ...customizeState[nudgeFields.optionValue],
        [name]: value,
      },
    };
    setCustomizeState(state);
    // update nudgefields
    let fields = {
      ...nudgeFields,
      customizeProperties: {
        ...nudgeFields.customizeProperties,
        [name]: {
          ...nudgeFields.customizeProperties[name],
          propertyValue: value,
        },
      },
    };
    setNudgeFields(fields);
  };
  const handleCheckBoxChange = (name, value) => {
    let state = {
      ...customizeState,
      [nudgeFields.optionValue]: {
        ...customizeState[nudgeFields.optionValue],
        [name]: value,
      },
    };
    setCustomizeState(state);
    // update nudgefields
    let fields = {
      ...nudgeFields,
      customizeProperties: {
        ...nudgeFields.customizeProperties,
        [name]: {
          ...nudgeFields.customizeProperties[name],
          propertyValue: value,
        },
      },
    };
    setNudgeFields(fields);
  };

  return (
    <div className="textField flex flex-col gap-2 mt-2">
      <div className="textField__container flex flex-col md:flex-row items-start md:items-center justify-between w-full">
        <RenderField
          property={property}
          propertyName={propertyName}
          handleNudgeFieldsChange={handleNudgeFieldsChange}
          handleCheckBoxChange={handleCheckBoxChange}
          urlField={urlField}
          setURLField={setURLField}
          allowedURLs={allowedURLs}
          setAllowedURLs={setAllowedURLs}
          prohibitedURLs={prohibitedURLs}
          setProhibitedURLs={setProhibitedURLs}
          customizeState={customizeState}
          nudgeTitle={nudgeTitle}
        />
      </div>
      <span className="text-red-500 text-sm">{maxLengthErrorText}</span>
    </div>
  );
};

const RenderField = (props) => {
  const {
    property,
    propertyName,
    handleNudgeFieldsChange,
    handleCheckBoxChange,
    urlField,
    setURLField,
    allowedURLs,
    setAllowedURLs,
    prohibitedURLs,
    setProhibitedURLs,
    customizeState,
    nudgeTitle,
  } = props;

  console.log("RenderField customizaState->", customizeState);

  switch (property.propertyType) {
    case "select":
      return (
        <Select
          property={property}
          propertyName={propertyName}
          handleNudgeFieldsChange={handleNudgeFieldsChange}
        />
      );
    case "multiSelect":
      return (
        <MultiSelectGeoLocation
          property={property}
          propertyName={propertyName}
          handleNudgeFieldsChange={handleNudgeFieldsChange}
        />
      );
    case "text":
      return (
        <Input
          property={property}
          propertyName={propertyName}
          handleNudgeFieldsChange={handleNudgeFieldsChange}
        />
      );
    case "color":
      return (
        <Input
          property={property}
          propertyName={propertyName}
          handleNudgeFieldsChange={handleNudgeFieldsChange}
        />
      );
    case "checkbox":
      return (
        <CheckBox
          property={property}
          propertyName={propertyName}
          handleCheckBoxChange={handleCheckBoxChange}
        />
      );
    case "number":
      return (
        <Input
          property={property}
          propertyName={propertyName}
          handleNudgeFieldsChange={handleNudgeFieldsChange}
        />
      );
    case "textarea":
      return (
        <Input
          property={property}
          propertyName={propertyName}
          handleNudgeFieldsChange={handleNudgeFieldsChange}
        />
      );
    case "urlBucket":
      return (
        <URLInput
          property={property}
          propertyName={propertyName}
          handleNudgeFieldsChange={handleNudgeFieldsChange}
          urlField={urlField}
          setURLField={setURLField}
          allowedURLs={allowedURLs}
          setAllowedURLs={setAllowedURLs}
          prohibitedURLs={prohibitedURLs}
          setProhibitedURLs={setProhibitedURLs}
          customizeState={customizeState}
          nudgeTitle={nudgeTitle}
        />
      );
    case "date":
      return (
        <DateInput
          property={property}
          propertyName={propertyName}
          handleNudgeFieldsChange={handleNudgeFieldsChange}
        />
      );

    case "urlList":
      return (
        <URLList
          property={property}
          propertyName={propertyName}
          handleNudgeFieldsChange={handleNudgeFieldsChange}
          customizeState={customizeState}
          nudgeTitle={nudgeTitle}
        />
      )
    case "multiZipCodes":
      return (
        <MultiZipInput
          property={property}
          propertyName={propertyName}
          handleNudgeFieldsChange={handleNudgeFieldsChange}
          customizeState={customizeState}
          nudgeTitle={nudgeTitle}
        />
      );

    case "multiKeyWords":
      return (
        <MultiKeyWords
          property={property}
          propertyName={propertyName}
          handleNudgeFieldsChange={handleNudgeFieldsChange}
          customizeState={customizeState}
          nudgeTitle={nudgeTitle}
        />
      )
    case "ipList":
      return (
        <IPList
          property={property}
          propertyName={propertyName}
          handleNudgeFieldsChange={handleNudgeFieldsChange}
          customizeState={customizeState}
          nudgeTitle={nudgeTitle}
        />
      )

    default:
      return null;
  }
};

const Select = (props) => {
  const { property, propertyName, handleNudgeFieldsChange } = props;

  return (
    <div className="w-full">
      <label
        htmlFor={property.propertyName}
        className="block text-sm font-medium mb-1"
      >
        {property.propertyName}
      </label>
      <select
        id={property.propertyName}
        name={property.propertyName}
        onChange={(e) => handleNudgeFieldsChange(propertyName, e.target.value)}
        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md text-gray-700"
        value={property.propertyValue}
      >
        {property.propertyOptions.map((option, index) => (
          <option key={index} value={option.optionValue}>
            {option.optionName}
          </option>
        ))}
      </select>
    </div>
  );
};

const MultiSelectGeoLocation = (props) => {
  const { property, propertyName, handleNudgeFieldsChange } = props;
  const [selectedOptions, setSelectedOptions] = useState(
    property.propertyValue === "all" ? property.propertyOptions.map(opt => opt.optionValue) : []
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (property.propertyValue !== "all") {
      setSelectedOptions(property.propertyValue);
    }
  }, [property.propertyValue]);

  const handleSelectAll = () => {
    const allOptions = property.propertyOptions.map((option) => option.optionValue);
    setSelectedOptions(allOptions);
    handleNudgeFieldsChange(propertyName, allOptions);
  };

  const handleClearAll = () => {
    setSelectedOptions([]);
    handleNudgeFieldsChange(propertyName, []);
  };

  const handleOptionChange = (optionValue) => {
    const updatedOptions = selectedOptions.includes(optionValue)
      ? selectedOptions.filter((option) => option !== optionValue)
      : [...selectedOptions, optionValue];
    setSelectedOptions(updatedOptions);
    handleNudgeFieldsChange(propertyName, updatedOptions);
  };

  const filteredOptions = property.propertyOptions.filter(option =>
    option.optionName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="w-full" ref={dropdownRef}>
      <label htmlFor={property.propertyName} className="block text-sm font-medium mb-1">
        {property.propertyName} 
      </label>
      <div className="relative">
        <div className="flex items-center">
          <input
            type="text"
            placeholder="Search Here...."
            value={searchTerm}
            onFocus={() => setIsDropdownVisible(true)}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="mb-2 p-2 border rounded w-full text-black"
          />
          <span className="ml-2 text-gray-800">({selectedOptions.length})</span>
        </div>
        {isDropdownVisible && (
          <div className="absolute z-10 w-full bg-white border rounded mt-1">
            <div className="flex justify-between items-center mb-2 p-2">
              <button onClick={handleSelectAll} className="text-sm text-blue-500">Select ALL</button>
              <button onClick={handleClearAll} className="text-sm text-red-500">Clear ALL</button>
            </div>
            <div className="border-t">
              <div className="max-h-40 overflow-y-scroll p-2">
                {filteredOptions.map((option, index) => (
                  <div key={option.optionValue} className="flex items-center mb-1">
                    <input
                      type="checkbox"
                      id={`${property.propertyName}-${option.optionValue}`}
                      checked={selectedOptions.includes(option.optionValue)}
                      onChange={() => handleOptionChange(option.optionValue)}
                      className="mr-2"
                    />
                    <label className="text-black" htmlFor={`${property.propertyName}-${option.optionValue}`}>{option.optionName}</label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// const MultiSelect = (props) => {
//   const { property, propertyName, handleNudgeFieldsChange } = props;
//   const [selectedOptions, setSelectedOptions] = useState(
//     property.propertyValue === "all" ? property.propertyOptions.map(opt => opt.optionValue) : []
//   );
//   const [searchTerm, setSearchTerm] = useState("");
//   const [isDropdownVisible, setIsDropdownVisible] = useState(false);
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     if (property.propertyValue !== "all") {
//       setSelectedOptions(property.propertyValue);
//     }
//   }, [property.propertyValue]);

//   const handleSelectAll = () => {
//     const allOptions = property.propertyOptions.map((option) => option.optionValue);
//     setSelectedOptions(allOptions);
//     handleNudgeFieldsChange(propertyName, allOptions);
//   };

//   const handleClearAll = () => {
//     setSelectedOptions([]);
//     handleNudgeFieldsChange(propertyName, []);
//   };

//   const handleOptionChange = (optionValue) => {
//     const updatedOptions = selectedOptions.includes(optionValue)
//       ? selectedOptions.filter((option) => option !== optionValue)
//       : [...selectedOptions, optionValue];
//     setSelectedOptions(updatedOptions);
//     handleNudgeFieldsChange(propertyName, updatedOptions);
//   };

//   const filteredOptions = property.propertyOptions.filter(option =>
//     option.optionName.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const handleClickOutside = (event) => {
//     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//       setIsDropdownVisible(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   return (
//     <div className="w-full" ref={dropdownRef}>
//       <label htmlFor={property.propertyName} className="block text-sm font-medium mb-1">
//         {property.propertyName} 
//       </label>
//       <div className="relative">
//         <div className="flex items-center">
//           <input
//             type="text"
//             placeholder="Search Here...."
//             value={searchTerm}
//             onFocus={() => setIsDropdownVisible(true)}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="mb-2 p-2 border rounded w-full text-black"
//           />
//           <span className="ml-2 text-gray-800">({selectedOptions.length})</span>
//         </div>
//         {isDropdownVisible && (
//           <div className="absolute z-10 w-full bg-white border rounded mt-1">
//             <div className="flex justify-between items-center mb-2 p-2">
//               <button onClick={handleSelectAll} className="text-sm text-blue-500">Select ALL</button>
//               <button onClick={handleClearAll} className="text-sm text-red-500">Clear ALL</button>
//             </div>
//             <div className="border-t">
//               <div className="max-h-40 overflow-y-scroll p-2">
//                 {filteredOptions.map((option, index) => (
//                   <div key={option.optionValue} className="flex items-center mb-1">
//                     <input
//                       type="checkbox"
//                       id={`${property.propertyName}-${option.optionValue}`}
//                       checked={selectedOptions.includes(option.optionValue)}
//                       onChange={() => handleOptionChange(option.optionValue)}
//                       className="mr-2"
//                     />
//                     <label className="text-black" htmlFor={`${property.propertyName}-${option.optionValue}`}>{option.optionName}</label>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

const MultiZipInput = (props) => {
  const {
    property,
    propertyName,
    handleNudgeFieldsChange,
    customizeState,
    nudgeTitle
  } = props;

  const [zipInput, setZipInput] = useState("");
  const [zipcodes, setZipcodes] = useState(
    customizeState?.nudgeShowing?.GeoZipcodes?.length
      ? customizeState.nudgeShowing.GeoZipcodes
      : []
  );
  const [open, setOpen] = useState(false);

  console.log("zipcodes", zipcodes);
  console.log("propertyName", propertyName);

  const handleAddZipcode = () => {
    if (zipInput.trim() !== "" && !zipcodes.includes(zipInput)) {
      const updated = [...zipcodes, zipInput];
      setZipcodes(updated);
      console.log("updated", updated);
      handleNudgeFieldsChange(propertyName, updated);
      setZipInput("");
    }
  };

  const handleRemoveZipcode = (indexToRemove) => {
    const updated = zipcodes.filter((_, index) => index !== indexToRemove);
    setZipcodes(updated);
    handleNudgeFieldsChange(propertyName, updated);
  };

  return (
    <div className="flex flex-col gap-2 w-full">
      <label
        htmlFor={property.propertyName}
        className="block text-sm font-medium"
      >
        {property.propertyName}
      </label>

      {/* Input field and Add button */}
      <div className="flex gap-1 w-full">
        <input
          onChange={(e) =>
            setZipInput(e.target.value) // digits only
          }
          className="text-gray-700 py-1 px-2 rounded outline-none w-full"
          type="text"
          maxLength={6}
          id={property.propertyName}
          value={zipInput}
          placeholder="Enter a Zip Code"
        />
        <button
          disabled={zipInput.length === 0}
          onClick={handleAddZipcode}
        >
          <IoIosAddCircle
            className={
              zipInput.length === 0
                ? "text-slate-400 text-2xl"
                : "text-2xl"
            }
          />
        </button>
      </div>

      {/* View All Zipcodes button */}
      <button
        type="button"
        className="rounded block mt-1 md:mt-6 ml-auto bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
        onClick={() => setOpen(true)}
      >
        View All Zip Codes |{" "}
        <span className={zipcodes.length === 0 ? "text-[#94A3B8]" : ""}>
          {zipcodes.length-1}
        </span>
      </button>

      {/* Modal for showing all zipcodes */}
      <ModalPopUp
        open={open}
        setOpen={setOpen}
        URLs={zipcodes}
        handleRemoveURL={handleRemoveZipcode}
        nudgeTitle={nudgeTitle}
        type="Zip Codes"
      />
    </div>
  );
};

const URLInput = (props) => {
  const {
    property,
    propertyName,
    handleNudgeFieldsChange,
    customizeState,
    nudgeTitle
    // urlField,
    // setURLField,
    // allowedURLs,
    // setAllowedURLs,
    // prohibitedURLs,
    // setProhibitedURLs,
  } = props;
  const [urlField, setURLField] = useState("");
  const [allowedURLFieldValue, setAllowedURLFieldValue] = useState("");
  const [prohibitedURLFieldValue, setProhibitedURLFieldValue] = useState("");
  const [allowedURLs, setAllowedURLs] = useState(
    customizeState?.nudgeShowing?.allowed !== ""
      ? customizeState?.nudgeShowing?.allowed
      : []
  );
  const [prohibitedURLs, setProhibitedURLs] = useState(
    customizeState?.nudgeShowing?.prohibited !== ""
      ? customizeState?.nudgeShowing?.prohibited
      : []
  );
  const [open, setOpen] = useState(false);
  // console.log("propertyName", propertyName);
  const handleAddAllowedURLs = () => {
    if (propertyName === "allowed") {
      if (
        allowedURLs === undefined ||
        allowedURLs === "" ||
        allowedURLs.length === 0
      ) {
        setAllowedURLs([allowedURLFieldValue]);
      } else {
        const modifiedUrlList = allowedURLs;
        modifiedUrlList.push(allowedURLFieldValue);
        console.log("modifiedURLList", modifiedUrlList);
        setAllowedURLs(modifiedUrlList);
      }
      // handleNudgeFieldsChange("Allowed Pages", allowedURLs);
      handleNudgeFieldsChange(propertyName, allowedURLs);
      setAllowedURLFieldValue("");
    } else if (propertyName === "prohibited") {
      prohibitedURLs.push(prohibitedURLFieldValue);
      const modifiedUrlList = prohibitedURLs;
      console.log("modifiedURLList", modifiedUrlList);
      setProhibitedURLs(modifiedUrlList);
      // handleNudgeFieldsChange("Allowed Pages", allowedURLs);
      handleNudgeFieldsChange(propertyName, prohibitedURLs);
      setProhibitedURLFieldValue("");
    }
  };
  const handleRemoveURL = (indexToRemove) => {
    if (propertyName === "allowed") {
      allowedURLs.splice(indexToRemove, 1);
      console.log("modifiedURLList", allowedURLs);
      if (allowedURLs.length === 0) {
        setAllowedURLs(["HandleEmptyArrayValue"]);
        handleNudgeFieldsChange(propertyName, ["HandleEmptyArrayValue"]);
      } else {
        setAllowedURLs(allowedURLs);
        handleNudgeFieldsChange(propertyName, allowedURLs);
      }
    } else if (propertyName === "prohibited") {
      prohibitedURLs.splice(indexToRemove, 1);
      console.log("modifiedURLList", prohibitedURLs);
      setProhibitedURLs(prohibitedURLs);
      handleNudgeFieldsChange(propertyName, prohibitedURLs);
    }
  };

  // useEffect(() => {
  //   if (allowedURLs.length > 1 && allowedURLs.includes("*")) {
  //     // Remove "*" if multiple URLs exist
  //     setAllowedURLs(prev => prev.filter(url => url !== "*"));
  //   } else if (allowedURLs.length === 1 && !allowedURLs.includes("*")) {
  //     // Add "*" if only one URL exists
  //     setAllowedURLs(prev => [...prev, "*"]);
  //   }
  // }, [allowedURLs]);
  // console.log("allowedURLs", allowedURLs)

  return (
    <div className="flex flex-col gap-2 w-full">
      <label
        htmlFor={property.propertyName}
        className="block text-sm font-medium"
      >
        {property.propertyName}
      </label>
      <div className="flex gap-1 w-full">
        <input
          onChange={(e) => {
            if (propertyName === "allowed") {
              setAllowedURLFieldValue(e.target.value);
            } else {
              setProhibitedURLFieldValue(e.target.value);
            }
          }}
          className="text-gray-700 py-1 px-2 rounded outline-none w-full"
          type={property.propertyType}
          id={property.propertyName}
          value={
            propertyName === "allowed"
              ? allowedURLFieldValue
              : prohibitedURLFieldValue
          }
          placeholder="Enter a URL"
        />
        <button
          disabled={
            (propertyName === "allowed"
              ? allowedURLFieldValue.length
              : prohibitedURLFieldValue.length) === 0
              ? true
              : false
          }
          onClick={handleAddAllowedURLs}
        >
          <IoIosAddCircle
            className={
              (propertyName === "allowed"
                ? allowedURLFieldValue.length
                : prohibitedURLFieldValue.length) === 0
                ? "text-slate-400 text-2xl"
                : "text-2xl"
            }
          />
        </button>
      </div>
      <button
        type="button"
        className="rounded block mt-1 md:mt-6 ml-auto bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
        onClick={() => setOpen(!open)}
      >
        View All URLs |{" "}
        <span
          className={`${propertyName === "allowed"
            ? allowedURLs.length - 1 === 0
              ? " text-[#94A3B8]"
              : ""
            : prohibitedURLs.length - 1 === 0
              ? " text-[#94A3B8]"
              : ""
            } `}
        >
          {propertyName === "allowed"
            ? allowedURLs.length - 1
            : prohibitedURLs.length - 1}
        </span>
      </button>

      <div className="w-full max-h-[100px] overflow-y-auto">
        {propertyName === "allowed" ? (
          <ModalPopUp
            open={open}
            setOpen={setOpen}
            URLs={allowedURLs}
            handleRemoveURL={handleRemoveURL}
            nudgeTitle={nudgeTitle}
            type="Allowed URLs"
          />
        ) : (
          prohibitedURLs?.map((URL, key) => {
            return (
              <ModalPopUp
                open={open}
                setOpen={setOpen}
                URLs={prohibitedURLs}
                handleRemoveURL={handleRemoveURL}
                nudgeTitle={nudgeTitle}
                type="Prohibited URLs"
              />
            );
          })
        )}
      </div>
    </div>
  );
};

const Input = (props) => {
  const { property, propertyName, handleNudgeFieldsChange } = props;
  return (
    <div className="w-full">
      <label
        htmlFor={property.propertyName}
        className="block text-sm font-medium mb-1"
      >
        {property.propertyName}
      </label>
      {property?.propertyType === "textarea" ? (
        <textarea
          onChange={(e) =>
            handleNudgeFieldsChange(propertyName, e.target.value)
          }
          className="text-gray-700 py-1 px-2 rounded outline-none w-full"
          type="textarea"
          id={property.propertyName}
          value={property.propertyValue}
        />
      ) : (
        <input
          onChange={(e) =>
            handleNudgeFieldsChange(propertyName, e.target.value)
          }
          className="text-gray-700 py-1 px-2 rounded outline-none w-full"
          type={property.propertyType}
          id={property.propertyName}
          value={property.propertyValue}
        />
      )}
    </div>
  );
};

const CheckBox = (props) => {
  const { property, propertyName, handleCheckBoxChange } = props;

  return (
    <div className="w-full">
      <label
        htmlFor={property.propertyName}
        className="block text-sm font-medium mb-1"
      >
        {property.propertyName}
      </label>
      <input
        onChange={(e) => handleCheckBoxChange(propertyName, e.target.checked)}
        className="text-gray-700 py-1 px-2 rounded outline-none"
        type={property.propertyType}
        id={property.propertyName}
        checked={property.propertyValue}
      />
    </div>
  );
};

const TextArea = (props) => {
  const { property, propertyName, handleNudgeFieldsChange } = props;

  return (
    <div className="w-full">
      <label
        htmlFor={property.propertyName}
        className="block text-sm font-medium mb-1"
      >
        {property.propertyName}
      </label>
      <textarea
        onChange={(e) =>
          handleNudgeFieldsChange(propertyName, e.target.value)
        }
        className="text-gray-700 py-1 px-2 rounded outline-none w-full"
        id={property.propertyName}
        value={property.propertyValue}
      />
    </div>
  );
};

const DateInput = (props) => {
  const { property, propertyName, handleNudgeFieldsChange } = props;
  const today = new Date().toISOString().split("T")[0];

  return (
    <div className="w-full">
      <label htmlFor={property.propertyName} className="block text-sm font-medium">
        {property.propertyName}
      </label>
      <input
        onChange={(e) => handleNudgeFieldsChange(propertyName, e.target.value)}
        className="text-gray-700 py-1 px-2 rounded outline-none w-full"
        type="date"
        id={property.propertyName}
        value={property.propertyValue}
        min={today}
      />
    </div>
  );
};

const URLList = (props) => {
  const {
    property,
    propertyName,
    handleNudgeFieldsChange,
    customizeState,
    nudgeTitle,
  } = props;

  const customizeProps = property?.propertyValue?.customizeProperties || {};
  const options = Object.keys(customizeProps || {});
  const [selectedOption, setSelectedOption] = useState(() => options[0] || "");
  const [urlField, setUrlField] = useState("");
  const [urlBuckets, setUrlBuckets] = useState({});
  const [modalOpen, setModalOpen] = useState(false);

  console.log("property->", property);
  console.log("propertyName->", propertyName);
  console.log("customizeState",customizeState);

   useEffect(() => {
    const initial = {};
    options.forEach((key) => {
      const stateVal = customizeState?.nudgeShowing?.[propertyName]?.customizeProperties?.[key]?.propertyValue;
      initial[key] = Array.isArray(stateVal) ? [...stateVal] : [];
    });
    setUrlBuckets(initial);
  }, []);

  const handleAddURL = () => {
    if (!urlField.trim()) return;
    const updatedList = [...(urlBuckets[selectedOption] || []), urlField.trim()];
    const newBuckets = { ...urlBuckets, [selectedOption]: updatedList };

    setUrlBuckets(newBuckets);
    setUrlField("");

    handleNudgeFieldsChange(propertyName, {
      ...customizeState?.nudgeShowing?.[propertyName],
      customizeProperties: {
        ...customizeState?.nudgeShowing?.[propertyName]?.customizeProperties,
        [selectedOption]: {
          ...customizeProps[selectedOption],
          propertyValue: updatedList,
        },
      },
    });
  };

  const handleRemoveURL = (bucketKey,indexToRemove) => {
    const updatedList = [...(urlBuckets[bucketKey] || [])];
    updatedList.splice(indexToRemove, 1);
    const newList = updatedList.length ? updatedList : ["HandleEmptyArrayValue"];
    const newBuckets = { ...urlBuckets, [bucketKey]: newList };

    setUrlBuckets(newBuckets);

    handleNudgeFieldsChange(propertyName, {
      ...customizeState?.nudgeShowing?.[propertyName],
      customizeProperties: {
        ...customizeState?.nudgeShowing?.[propertyName]?.customizeProperties,
        [bucketKey]: {
          ...customizeProps[bucketKey],
          propertyValue: newList,
        },
      },
    });
  };

  if (!selectedOption || !customizeProps[selectedOption]) {
    return <div>No URL configuration available.</div>;
  }

  console.log("urlbucket->", urlBuckets);

  return (
    <div className="flex flex-col gap-2 w-full">
      <div htmlFor={property.propertyName}
        className="block text-sm font-medium">
            {property.propertyName} :
      </div>
      <div className="flex flex-row items-start gap-1 w-full">
        
        {/* Dropdown (left side) */}
        <div className="w-1/4">
          <label className="text-sm font-medium mb-1 block ">
            Select URL Type
          </label>
          <select
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.target.value)}
            className="p-1 rounded border border-gray-300 bg-white text-gray-700  focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
          >
            {options.map((key) => (
              <option
                key={key}
                value={key}
                className="text-gray-800 font-medium"
              >
                {customizeProps[key].propertyName}
              </option>
            ))}
          </select>
        </div>

        {/* Input and URL viewer (right side) */}
        <div className="w-3/4">
          <label className="block text-sm font-medium ">
            {customizeProps[selectedOption]?.propertyName}
          </label>
          <div className="flex gap-1 w-full mt-1">
            <input
              type="text"
              className="text-gray-700 py-1 px-2 rounded outline-none w-full border"
              value={urlField}
              placeholder={`Enter ${customizeProps[selectedOption]?.propertyName}`}
              onChange={(e) => setUrlField(e.target.value)}
            />
            <button onClick={handleAddURL} disabled={!urlField.trim()}>
              <IoIosAddCircle
                className={urlField.trim() ? "text-2xl" : "text-slate-400 text-2xl"}
              />
            </button>
          </div>

          <button
            type="button"
            className="rounded block mt-2 ml-auto bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
            onClick={() => setModalOpen(!modalOpen)}
          >
            Show all URLs | {Object.values(urlBuckets).flat().filter(url => url !== "HandleEmptyArrayValue").length || 0}
          </button>

          <div className="w-full mt-2 max-h-[100px] overflow-y-auto">
            <ModalPopUp2
              open={modalOpen}
              setOpen={setModalOpen}
              URLs={urlBuckets || []}
              handleRemoveURL={handleRemoveURL}
              nudgeTitle={nudgeTitle}
              type={customizeProps[selectedOption]?.propertyName}
            />
          </div>
        </div>
      </div>
    </div>

  );
};

const IPList = (props) => {
  const {
    property,
    propertyName,
    handleNudgeFieldsChange,
    customizeState,
    nudgeTitle,
  } = props;

  const customizeProps = property?.propertyValue?.customizeProperties || {};
  const options = Object.keys(customizeProps || {});
  const [selectedOption, setSelectedOption] = useState(() => options[0] || "");
  const [urlField, setUrlField] = useState("");
  const [urlBuckets, setUrlBuckets] = useState({});
  const [modalOpen, setModalOpen] = useState(false);

  console.log("ip property->", property);
  console.log("ip propertyName->", propertyName);
  console.log("ip customizeState",customizeState);

   useEffect(() => {
    const initial = {};
    options.forEach((key) => {
      const stateVal = customizeState?.nudgeShowing?.[propertyName]?.customizeProperties?.[key]?.propertyValue;
      initial[key] = Array.isArray(stateVal) ? [...stateVal] : [];
    });
    setUrlBuckets(initial);
  }, []);

  const handleAddURL = () => {
    if (!urlField.trim()) return;
    const updatedList = [...(urlBuckets[selectedOption] || []), urlField.trim()];
    const newBuckets = { ...urlBuckets, [selectedOption]: updatedList };

    setUrlBuckets(newBuckets);
    setUrlField("");

    handleNudgeFieldsChange(propertyName, {
      ...customizeState?.nudgeShowing?.[propertyName],
      customizeProperties: {
        ...customizeState?.nudgeShowing?.[propertyName]?.customizeProperties,
        [selectedOption]: {
          ...customizeProps[selectedOption],
          propertyValue: updatedList,
        },
      },
    });
  };

  const handleRemoveURL = (bucketKey,indexToRemove) => {
    const updatedList = [...(urlBuckets[bucketKey] || [])];
    updatedList.splice(indexToRemove, 1);
    const newList = updatedList.length ? updatedList : ["HandleEmptyArrayValue"];
    const newBuckets = { ...urlBuckets, [bucketKey]: newList };

    setUrlBuckets(newBuckets);

    handleNudgeFieldsChange(propertyName, {
      ...customizeState?.nudgeShowing?.[propertyName],
      customizeProperties: {
        ...customizeState?.nudgeShowing?.[propertyName]?.customizeProperties,
        [bucketKey]: {
          ...customizeProps[bucketKey],
          propertyValue: newList,
        },
      },
    });
  };

  if (!selectedOption || !customizeProps[selectedOption]) {
    return <div>No URL configuration available.</div>;
  }

  console.log("ipbucket->", urlBuckets);

  return (
    <div className="flex flex-col gap-2 w-full">
      <div htmlFor={property.propertyName}
        className="block text-sm font-medium">
            {property.propertyName} :
      </div>
      <div className="flex flex-row items-start gap-1 w-full">
        
        {/* Dropdown (left side) */}
        <div className="w-1/4">
          <label className="text-sm font-medium mb-1 block ">
            Select Type
          </label>
          <select
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.target.value)}
            className="p-1 rounded border border-gray-300 bg-white text-gray-700  focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
          >
            {options.map((key) => (
              <option
                key={key}
                value={key}
                className="text-gray-800 font-medium"
              >
                {customizeProps[key].propertyName}
              </option>
            ))}
          </select>
        </div>

        {/* Input and URL viewer (right side) */}
        <div className="w-3/4">
          <label className="block text-sm font-medium ">
            {customizeProps[selectedOption]?.propertyName}
          </label>
          <div className="flex gap-1 w-full mt-1">
            <input
              type="text"
              className="text-gray-700 py-1 px-2 rounded outline-none w-full border"
              value={urlField}
              placeholder={`Enter ${customizeProps[selectedOption]?.propertyName} IP (e.g.,117.98.92.52)`}
              onChange={(e) => setUrlField(e.target.value)}
            />
            <button onClick={handleAddURL} disabled={!urlField.trim()}>
              <IoIosAddCircle
                className={urlField.trim() ? "text-2xl" : "text-slate-400 text-2xl"}
              />
            </button>
          </div>

          <button
            type="button"
            className="rounded block mt-2 ml-auto bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
            onClick={() => setModalOpen(!modalOpen)}
          >
            Show all IP's | {Object.values(urlBuckets).flat().filter(url => url !== "HandleEmptyArrayValue").length || 0}
          </button>

          <div className="w-full mt-2 max-h-[100px] overflow-y-auto">
            <ModalPopUp2
              open={modalOpen}
              setOpen={setModalOpen}
              URLs={urlBuckets || []}
              handleRemoveURL={handleRemoveURL}
              nudgeTitle={nudgeTitle}
              type={customizeProps[selectedOption]?.propertyName}
            />
          </div>
        </div>
      </div>
    </div>

  );
};

const MultiKeyWords = (props) => {
  const {
    property,
    propertyName,
    handleNudgeFieldsChange,
    customizeState,
    nudgeTitle,
  } = props;

  const userWebsiteURL = useSelector(SelectUserWebsiteURL)
  let existingKeywords = customizeState?.nudgeShowing?.[propertyName]?.propertyValue || property?.propertyValue || [];
  const existingKeywordsAfterFilter = existingKeywords.filter(k => k.keyword!=="HandleEmptyArrayValue");
  console.log("existingKeywords-------------------------->", existingKeywordsAfterFilter);

  const [keywords, setKeywords] = useState(existingKeywordsAfterFilter);
  const [keywordField, setKeywordField] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedTopKeywords, setSelectedTopKeywords] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [topKeywords, setTopKeywords] = useState([]);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    let TopKeywords = customizeState?.nudgeShowing?.[propertyName]?.propertyOptions || property?.propertyOptions || [];

    if(TopKeywords.length === 0){
      handleFetchTopKeywords();
    }
    else{
      setTopKeywords(TopKeywords);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleAddKeyword = async () => {
    let SelectedKeywords = []

    if(selectedTopKeywords.length !== 0 ){
      SelectedKeywords.push(...selectedTopKeywords);
      setSelectedTopKeywords([]);
    }

    if(SelectedKeywords.length === 0){
      return;
    }

    const existingKeywordNames = existingKeywords.map(k => k.keyword);

    // Remove duplicates and already existing keywords
    SelectedKeywords = Array.from(new Set(SelectedKeywords)).filter(k => !existingKeywordNames.includes(k));

    let new_keywords = SelectedKeywords.map(keyword => ({ keyword, urls: [] }));

    topKeywords.forEach(item => {
      if (SelectedKeywords.includes(item.keyword)) {
        new_keywords = new_keywords.map(kw => {
          if (kw.keyword === item.keyword) {
            return { ...kw, urls: item.urls };
          }
          return kw;
        });
      }
    });

    console.log("new_keywords--------------------------------->", new_keywords);
    setKeywords(prev => [...prev, ...new_keywords]);
    handleNudgeFieldsChange(propertyName, [...existingKeywords, ...new_keywords]);
  };

  const handleRemoveKeyword = (indexToRemove) => {
    let updatedKeywords = keywords.filter((_, index) => index !== indexToRemove);
    setKeywords(updatedKeywords);

    let forErrorHandling =  [{
            "keyword": "HandleEmptyArrayValue",
            "urls": [
                "HandleEmptyArrayValue"
            ]
    }]

    // Update parent state
    handleNudgeFieldsChange(propertyName, [...forErrorHandling,...updatedKeywords]);
  };

  // Handle checkbox selection for TopKeywords
  const handleTopKeywordChange = (keyword) => {
    setSelectedTopKeywords(prev => {
      if (prev.includes(keyword)) {
        return prev.filter(k => k !== keyword);
      } else {
        return [...prev, keyword];
      }
    });
  };

  // Close dropdown when clicking outside
  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  function filterKeywordsAndUrls(data) {
    const keywordMap = new Map();

    // Process each result
    data.results.forEach((item) => {
      const keyword = item.keyword;
      const url = item.topRankedUrl;

      // Skip if no valid keyword or URL
      if (!keyword || !url) return;

      // If keyword exists, add URL to its set
      if (keywordMap.has(keyword)) {
        keywordMap.get(keyword).add(url);
      } else {
        // Create new set with the URL
        keywordMap.set(keyword, new Set([url]));
      }
    });

    // Convert Map to array of objects
    const result = Array.from(keywordMap).map(([keyword, urlSet]) => ({
      keyword: keyword,
      urls: Array.from(urlSet),
    }));

    return result;
  }

  // fetch the TopKeywords
  const handleFetchTopKeywords = async () => {
    setLoading(true);
    
    try {
      const topKeywordsResponse = await fetch('https://us-central1-causalfunnel-21.cloudfunctions.net/Spyfu_Get_Urls_From_Seo_KeyWords', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          domain: userWebsiteURL,
        })
      });
      
      if (!topKeywordsResponse.ok) {
        throw new Error('Failed to fetch top keywords');
      }
      
      const topKeywordsData = await topKeywordsResponse.json();
      const filteredData = filterKeywordsAndUrls(topKeywordsData);
      console.log("filteredData", filteredData);
      setTopKeywords(filteredData);
      
    } catch (error) {
      console.error('Error fetching top keywords:', error);
      alert('Failed to fetch top keywords. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="flex flex-col gap-1 w-full">
        <div className="block text-sm font-medium">
          {property.propertyName} :
        </div>
        <div className="w-full">
          <div className="flex gap-1 w-full mt-1" >
            {/* Conditional rendering based on topKeywords availability */}
            {topKeywords && (
              // Dropdown with checkboxes for topKeywords
              <div className="w-full relative" ref={dropdownRef}>
                <button
                  type="button"
                  onClick={handleDropdownToggle}
                  className="w-full p-2 text-left border border-gray-300 rounded bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 flex justify-between items-center"
                >
                  <span className="truncate">
                    {selectedTopKeywords.length > 0 
                      ? `${selectedTopKeywords.length} keyword(s) selected`
                      : 'Select keywords...'
                    }
                  </span>
                  <svg className={`w-4 h-4 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                
                {isDropdownOpen && (
                  <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto">
                    {topKeywords.map((item, index) => (
                      <div key={index} className="flex items-center px-3 py-2 hover:bg-gray-50">
                        <input
                          type="checkbox"
                          id={`top-keyword-${index}`}
                          checked={selectedTopKeywords.some(keyword => keyword === item.keyword)}
                          onChange={() => handleTopKeywordChange(item.keyword)}
                          className="mr-3 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                        />
                        <label 
                          htmlFor={`top-keyword-${index}`}
                          className="flex-1 cursor-pointer"
                        >
                          <div className="text-sm text-gray-700 font-medium">
                            {item.keyword}
                          </div>
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            
            {/* Add button */}
            <button
              onClick={handleAddKeyword}
              disabled={
                loading || 
                (topKeywords && topKeywords.length > 0 ? selectedTopKeywords.length === 0 : !keywordField.trim())
              }
              className="flex items-center justify-center p-2 rounded border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <div className="loader border-2 border-gray-300 border-t-blue-500 rounded-full w-5 h-5 animate-spin" />
              ) : (
                <IoIosAddCircle
                  className={
                    (topKeywords && topKeywords.length > 0 ? selectedTopKeywords.length > 0 : keywordField.trim())
                      ? "text-blue-500 text-2xl"
                      : "text-slate-400 text-2xl"
                  }
                />
              )}
            </button>
          </div>

          {/* Show selected keywords preview for dropdown mode */}
          {topKeywords && topKeywords.length > 0 && selectedTopKeywords.length > 0 && (
            <div className="mt-2 p-2 bg-blue-50 rounded border">
              <div className="text-xs text-blue-600 font-medium mb-1">Selected keywords:</div>
              <div className="flex flex-wrap gap-1">
                {selectedTopKeywords.map((keyword, index) => (
                  <span key={index} className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800">
                    {keyword}
                    <button
                      type="button"
                      onClick={() => handleTopKeywordChange(keyword)}
                      className="ml-1 text-blue-600 hover:text-blue-800"
                    >
                      ×
                    </button>
                  </span>
                ))}
              </div>
            </div>
          )}

          <div className="flex gap-2 mt-2 ml-auto justify-end">
            {/* <button
              type="button"
              className="rounded bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              onClick={() => handleFetchTopKeywords()}
            >
              Update Top Keyworlds
            </button> */}
            <button
              type="button"
              className="rounded bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              onClick={() => setModalOpen(!modalOpen)}
            >
              Show all Keywords | {keywords.length}
            </button>
          </div>
          
          <div className="w-full mt-2 max-h-[100px] overflow-y-auto">
            <ModalPopUpForSeoKeywords
              open={modalOpen}
              setOpen={setModalOpen}
              keywords={keywords}
              handleRemoveKeyword={handleRemoveKeyword}
              nudgeTitle={nudgeTitle}
              type="Keywords"
            />
          </div>
        </div>
      </div>
  );
};

export default NudgeFieldsURL;
